const global = {
  defaultSystemName: 'Zhong Xun・Wisdom Position System',
  alarmHandle: 'Alarm Handling',
  alarmHandleDescription: 'Please enter alarm handling description !',
  alarmHandleSuccess: 'Dispose Alarm Successfully',
  selectTime: 'Select Time',
  selectDate: 'Select Date',
  event: 'Event',
  noramlAlarm: 'Noraml',
  importantAlarm: 'Important',
  fearfulAlarm: 'Fearful',
  processed: 'Checked',
  undisposed: 'Undisposed',
  showAlarmPosition: 'Show Position',
  fenceAlarm: 'Fence Alarm',
  today: 'Today',
  lastThreeDays: 'Last Three Days',
  lastSevenDays: 'Last Seven Days',
  lastThirtyDays: 'Last Thirty Days',
  thisWeek: 'This Week',
  thisMounth: 'This Mounth',
  tomorrow: 'Tomorrow',
  alarmType: 'Alarm Type',
  alarmTime: 'Occurred Time',
  alarmLevel: 'Alarm Level',
  alarmStatu: 'Alarm Statu',
  alarmPosition: 'Alarm Position',
  alarmDescription: 'Description',
  alarmAction: 'Action',
  totalRecords: 'Total {num} Records',
  operator: 'Operator',
  description: 'Description',
  time: 'Time',
  location: 'Location',
  OK: 'OK',
  slow: 'Slow',
  verySlow: 'Very Slow',
  noraml: 'Noraml',
  fast: 'Fast',
  veryFast: 'Very Fast',
  noInfo: 'No Information',
  trackSearch: 'Search Track',
  personalTrack: 'Personal Track',
  stayTime: ' Duration Time ',
  occurAlarm: ' Occured Alarm ',
  reason: ' Reason ',
  alarmInfo: ' Alarm Info ',
  basicInfo: 'Basic Info',
  allPoints: 'All Points',
  stayPoints: 'Stay Points',
  alarmPoints: 'Alarm Points',
  movePoints: 'Move Points',
  inputFliterTip: 'please input filter key',
  edit: 'Edit',
  commitSuccess: 'Commit Modified Successfully !',
  resetPassword: 'Reset Password',
  oldPassword: 'Old Password',
  oldPasswordTip: 'Please Input Old Password',
  newPassword: 'New Password',
  newPasswordTip: 'Please Input New Password',
  confirmPassword: 'Confirm Password',
  confirmPasswordTip: 'Please Input Confirm Password',
  confirmError: 'The two passwords did not match',
  resetPasswordSuccess: 'Reset Password Successfully',
  upload: 'Upload',
  delete: 'Delete',
  tips: 'Tips',
  imgTypeTip: ' Please upload .png .jpg .jpeg .bmp image file',
  imgPngTip: ' Please upload .png with transparent background image file',
  imgSizeTip: ' The upload image file must be less than 1MB size ',
  set: '  Set',
  none: ' none',
  enable: ' Enable',
  disable: ' Disable',
  loading: ' loading...',
  nonsupport: ' nonsupport',
  yes: ' YES',
  no: ' NO',
  forbidIn: ' Forbid In',
  forbidOut: ' Forbid Out',
  call: ' Call',
  dispose: 'Dispose',
  currentOrg: 'Current',
  all: 'All',
  hello: 'Hello ',
  logout: 'Logout',
  selectedNum: ' Selected {num} Records',
  confirm: 'Are you sure what you will to do ?',
  create: 'Create',
  org: 'Organiztion',
  export: 'Export',
  moreOperation: 'More operation',
  second: ' second',
  minute: ' minutes',
  hour: ' hour',
  detail: 'Detail',
  action: 'Action',
  cancel: 'Cancel',
  next: 'Next',
  pre: 'Pre',
  exportList: 'Export list',
  deleteConfirm: 'Sure to delete?',
  checkXlsx: 'Please upload a .xlsx file',
  import: 'Import',
  changeBelong: 'Change Belong',
  bind: 'Bind',
  unbind: 'Unbind',
  absent: 'Absent',
  option: 'Option',
  track: 'Track',
  fence: 'Fence',
  onAbsent: 'on leave',
  preAbsent: 'pre leave',
  isRequired: 'this value is required',
  modify: 'Modify',
  noramlAbsent: 'noraml',
  helpDocs: 'FAQ',
  download: 'Download',
  deviceDocs: 'Device Docs',
  systemDocs: 'System Docs',
  scanQRToDownload: 'scan QR code to download android app',
  androidAPPDocs: 'Android Docs',
  wxminAppDocs: 'WX minapp Docs',
  scanQRToWXapp: 'Please use WeiXin APP scan QR code to open WX mini app',
  status: 'Status',
  normal: 'Complete',
  collection: 'Collection...',
  segregationAddress: 'Segregation Addr',
  terminal: 'Terminal',
  collectFailed: 'Collect Failed',
  chinese: 'Chinese',
  english: 'English',
  russian: 'Russian',
  timesPerMinute:'times per minute',
  temperature:'℃',
  登陆:'login',
  分组:'group',  
  人员:'personnel',
  其他:'other',
  短信:'shortMessage',
  邮件:'email',
  设备:'device',
  系统:'system',
  创建子用户:'Create user',
  passwordLengthTip:'The password length should be between 6 and 15 characters!',
  pleaseSelectAScene:"Please select a scene",
  普管组:"General Management Group",
  宽管组:"Lenient Management Group",
  严管组:"Stringent Management Group",
  successful:'The operation was successful.',
  moveDevice:'Move the device to',
  personalConfigTip:'Personal configuration takes precedence over group configuration. When personal configuration exists, it will override the group configuration. The effective configuration will always be displayed in dark font.',
  sureDelete:'Are you sure you want to delete it?',
  deleteUserSuccessTip:'The user was successfully deleted.',
  入矫:'Entering correction',
  入组:'Entering group', 
  broadcast:'Broadcast',
  broadcastList:'Broadcast List',
  send:'Send',
  receiver:'Receiver',
  broadcastTip:'Please enter the broadcast content, which should be within 67 characters and should not contain special characters!',
  broadcastCount:'Broadcast count',
  broadcastInterval:'Broadcast interval (seconds)',
  close:'Close',
  total:'A total of',
  people:'people',
  sender:'Sender',
  content:'Information content',
  searchTip:'Please enter the search content!',
  none:'No information available.', 
  sendingStatus:'Sending status',
  fscg:'people sent successfully',
  fssb:'people failed to send',
  qz:'among whom',
  yd:'people have read',
  read:'read',
  unread:'unread',
  inProgress: 'people in progress',
  resend:'Resend',
  cg:'Success',
  sb:'Failure',
  wlbd:'Failure (network fluctuation)',
  zxz:'In progress',
  sbzxsb:'Device execution failure',
  cs:'Failure (timeout)',
  wbdsb:'Failure (device not bound)',
  zt:'Status',
  dwfs:'Positioning method:',
  dwpl:'Positioning frequency',
  gpsyx:'GPS switch',
  smtzkg:'Life sign switch',
  pdjckg:'Wear detection switch',
  zdjpkg:'Auto frequency switch',
  enableShake:'Shake switch',
  qsrdz:'Please enter the address to be located',
  clj:'Long connection', 
  zxwzfwxt:"Zhong Xun・Intelligent Position System",
  "中文":'Chinese',
  "英文":'English',
  "俄语":'Russian',
  qsrdz:'Please enter the address to be located',
  很抱歉没有查询到轨迹记录:'Sorry, no trajectory records were found',
  cxfs:'Resend message successfully! Please check the results later',
  moveDevice:'Mobile devices to',
  提示:'Prompt',
  确认将:'Are you sure to modify the current group to the default group?',
  enableSos:'SOS switch',
  healthFreq:'Health sampling frequency',
    allTrack:'All track',
  inTrack:'In track',
  outTrack:'Out track',
  secondOnce:'second once',
  filterDistance:'Filter distance',
}
export default global
